import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'
import { client } from '@/proxy/client'

export const SELLER_STATUS = gql`
  query sellerStatus {
    seller {
      id
      shop {
        isOpen
        isTimeInsideWorking
      }
    }
  }
`

export const SELLER_STATUS_KEY = 'useSellerStatus'

export const useSellerStatus = () =>
  useQuery({
    queryKey: [SELLER_STATUS_KEY],
    queryFn: variables => client.request(SELLER_STATUS, variables),
  })
